/** @module ChangeTracking/AttributeEntryName */
define([
    "dojo/_base/declare",
    "csi/heading/StringTypeNotSortable",
    "csi/locale",
    "csi/reflection",
    "csi/xml",
    "ChangeTracking"
], function(declare,StringTypeNotSortable,locale,reflection,xml,ChangeTracking) {

    return declare(StringTypeNotSortable, {
        /**
         * @override
         *
         * C8-21202: In Change Log the Attribute Name should be “Value” for each individual Value Type under SpecificationDataSheetItem
         *
         */
        toValue: function(ctx, h) {
            var value = this._getValue(ctx, h);
            var type = this._getFormat(ctx, h);
            if (type == ChangeTracking.VALUE_ATTR_CLASS && ChangeTracking.VALUE_ATTRS.includes(value)) {
                value = ChangeTracking.VALUE_ATTR;
            }
            return this.formatValue(value, type);
        },

        /**
         * @override
         *
         * set the domain class in format in case it is empty
         */
        formatQueryFilterValue: function(ctx, value, format, bFloatingDates, bSelected) {
            if (!format && ctx && ctx.view && ctx.view._getQueryDomainClass()) {
                format = ctx.view._getQueryDomainClass().type;
            }
            
            const dc = reflection.getDomainClass(format);
            const rca = dc && dc.getAttribute(value);
            if (rca) {
                format = rca.getOwner().getType();
            }
            
            return this.inherited(arguments, [ctx, value, format, bFloatingDates, bSelected]);
        },

        /**
        * Render localized attribute name, assuming the format is the class name
        * @param {Any} value
        * @param {string} fmt
        * @return {string}
        */
        formatValue: function(value, fmt) {
            var localeName;
            if (value == ChangeTracking.VALUE_ATTR) {
                localeName = locale.resource(value);
            } else {
                localeName = locale.typeId(fmt, value);
            }
            return (fmt && localeName) || value;
        },

        /**
        * Return type owning changed attribute
        * @param {Context} ctx
        * @param {Heading} h
        * @return {string}
        */
        _getFormat: function(ctx, h) {
            var attrEntry = ctx.getNode();
            var nodeEntry = ctx.getNodeParent();
            var dc = reflection.getDomainClass(nodeEntry.DomainClass);
            var rca = dc && dc.getAttribute(attrEntry.$Name);
            return rca ? rca.getOwner().getType() : null;
        },

        canLink: function() {
            return false;
        }

    });
});
